import { getNextTextPosition, getPreviousTextPosition, inLastChild } from 'common/Prose/utils'
import { positionOfNodeAbove } from 'common/Prose/utils/positionOfNodeAbove'
import { findTableFromPos, isTableCell } from 'common/Prose/utils/table'
import { Axis, arrow, directionString } from 'common/Prose/utils/table/input'
import { schema } from 'prose-core'
import { TextSelection } from 'prosemirror-state'
import { isInTable } from 'prosemirror-tables'
import { findParentNodeOfType, getCellsInRow } from 'prosemirror-utils'
import { Command } from '../types'

export const moveDownInTable: Command = (state, dispatch, view) => {
  if (!isInTable(state)) return false

  if (dispatch && view) {
    return arrow(Axis.Vertical, 1)(state, dispatch, view)
  }

  return false
}

export const moveDownIntoTable: Command = (state, dispatch, view) => {
  if (isInTable(state) || !view?.endOfTextblock(directionString.Down) || inLastChild(state)) return false

  const $pos = state.selection.$anchor
  const finalPosInDoc = state.doc.nodeSize - 2
  const nextPos = Math.min($pos.start() + $pos.node().nodeSize + 1, finalPosInDoc)

  const selectionNextPos = TextSelection.create(state.doc, nextPos)
  const table = findParentNodeOfType(schema.nodes.table)(selectionNextPos)

  if (table) {
    let posBeforeText = getNextTextPosition(state.doc.resolve(nextPos))
    dispatch?.(state.tr.setSelection(new TextSelection(posBeforeText)))
    return true
  }

  return false
}

export const moveLeftInTable: Command = (state, dispatch, view) => {
  if (!isInTable(state)) return false

  if (dispatch && view) {
    return arrow(Axis.Horizontal, -1)(state, dispatch, view)
  }

  return false
}

export const moveLeftIntoTable: Command = (state, dispatch, view) => {
  if (isInTable(state)) return false

  const $potentialPositionAbove = positionOfNodeAbove(state)

  if (dispatch && view) {
    // if you're below a table and at the start of the node under the table
    if (isTableCell($potentialPositionAbove.parent) && view.endOfTextblock(directionString.Left)) {
      let $newCursorPosition = getPreviousTextPosition($potentialPositionAbove)

      dispatch(state.tr.setSelection(new TextSelection($newCursorPosition)))
      return true
    }
  }
  return false
}

export const moveRightInTable: Command = (state, dispatch, view) => {
  if (!isInTable(state)) return false

  if (dispatch && view) {
    return arrow(Axis.Horizontal, 1)(state, dispatch, view)
  }
  return false
}

export const moveRightIntoTable: Command = (state, dispatch, view) => {
  if (isInTable(state) || !view?.endOfTextblock(directionString.Right)) return false
  const nextPos = getNextTextPosition(state.selection.$from)
  const selectionNextPos = TextSelection.create(state.doc, nextPos.pos)

  const table = findParentNodeOfType(schema.nodes.table)(selectionNextPos)

  if (table) {
    dispatch?.(state.tr.setSelection(selectionNextPos))
    return true
  }

  return false
}

export const moveUpInTable: Command = (state, dispatch, view) => {
  if (!isInTable(state)) return false

  if (dispatch && view) {
    return arrow(Axis.Vertical, -1)(state, dispatch, view)
  }

  return false
}

export const moveUpIntoTable: Command = (state, dispatch) => {
  if (isInTable(state)) return false
  const prevPos = positionOfNodeAbove(state)
  const selectionPrevPos = TextSelection.create(state.doc, prevPos.pos)

  const table = findTableFromPos(prevPos.pos, state.doc)

  if (table) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rowCount = table.node.content.content!.length

    const cells = getCellsInRow(rowCount - 1)(selectionPrevPos)
    if (cells && cells.length) {
      const firstCell = cells[0]
      dispatch?.(state.tr.setSelection(TextSelection.create(state.doc, firstCell.start + 1)))
      return true
    }
  }
  return false
}
